// extracted by mini-css-extract-plugin
export default {"mainContainer":"styles_mainContainer__BTKWJ","bodyContainer":"styles_bodyContainer__ImOJq"};